module.exports = __webpack_public_path__ + "static/media/example_template.0759c0db.xlsx";